import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { AddSubOutcomeToOutcomeModalPage } from './add-sub-outcome-to-outcome-modal.page';

const routes: Routes = [
    {
        path: '',
        component: AddSubOutcomeToOutcomeModalPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes)
    ],
    declarations: [AddSubOutcomeToOutcomeModalPage]
})
export class AddSubOutcomeToOutcomeModalPageModule { }
